import "./style.css";
import "@fontsource/reddit-mono";

import { createApp } from "vue";

import PrimeVue from "primevue/config";
import "primevue/resources/themes/aura-light-blue/theme.css";
import "primeicons/primeicons.css";

import router from "./router.js";
import initCellComponents from "./cellComponents.js";
import AppLoader from "./AppLoader.vue";
import BinSelectionInput from "./BinSelectionInput.vue";
import Checkbox from "./Checkbox.vue";
import TableCell from "./TableCell.vue";

import Button from "primevue/button";
import SplitButton from "primevue/splitbutton";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmPopup from "primevue/confirmpopup";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import FloatLabel from "primevue/floatlabel";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputText from "primevue/inputtext";
import Listbox from "primevue/listbox";
import Menu from "primevue/menu";
import Menubar from "primevue/menubar";
import OverlayPanel from "primevue/overlaypanel";
import Panel from "primevue/panel";
import Ripple from "primevue/ripple";
import TieredMenu from "primevue/tieredmenu";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";

const app = createApp(AppLoader);
app.use(router);
app.use(PrimeVue, { ripple: true });
app.use(ConfirmationService);
app.use(ToastService);

app.component("BinSelectionInput", BinSelectionInput);
app.component("Checkbox", Checkbox);
app.component("TableCell", TableCell);

app.component("Button", Button);
app.component("SplitButton", SplitButton);
app.component("ConfirmPopup", ConfirmPopup);
app.component("Dialog", Dialog);
app.component("Dropdown", Dropdown);
app.component("FloatLabel", FloatLabel);
app.component("InputGroup", InputGroup);
app.component("InputGroupAddon", InputGroupAddon);
app.component("InputText", InputText);
app.component("Listbox", Listbox);
app.component("Menu", Menu);
app.component("Menubar", Menubar);
app.component("OverlayPanel", OverlayPanel);
app.component("Panel", Panel);
app.component("TieredMenu", TieredMenu);
app.component("Toast", Toast);
app.component("ToastService", ToastService);
app.directive("ripple", Ripple);

initCellComponents(app);
app.mount("#app");
